module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Title":"Rapport d\u0027anomalies de tout le monde","DisplayName":"Nom","BugsCount":"Nombre d\u0027anomalies causées","Ratio":"Ratio","TotalHours":"Nombre d\u0027heures travaillées"}}')
  delete Component.options._Ctor
}
